import React, {useEffect, useState} from 'react';
import AiHelpChat from "@/Core/AIHelp/AiHelpChat";
import Util from "@/Master/Util";
import SdkTrack from "@/Fwk/Kit/SdkTrack";
import UserConfig = AIHelpSupport.UserConfig;
import UserMgr from "@/Core/UserMgr";
import {confJson} from "@/app/config/confJson";
import UtilBrowser from "@/Master/UtilBrowser";

export class AiHelpManager {
    static Tag = "[AiHelp]";

    static AI_HELPER_KEY:string = "GAMEWAVELIMITED_app_addb14157c59461db56a31bf7a849acf";
    static AI_HELPER_DOMAIN:string = "gamewavelimited.aihelp.net";
    static AI_HELPER_APP_ID:string = "gamewavelimited_platform_7835be7fd83ab415979d6512d2afed32";

    static AI_HELPER_NO_VIP: string = "70050A001";    //（非R 非充值用户）AI Help ID：
    static AI_HELPER_VIP: string = "70050A003";    //（R 充值用户）AI Help ID：
    static AI_HELPER_BIG_VIP: string = "70050A002";    //（大Rvip3~7 充值用户）AI Help ID：
    static AI_HELPER_APP_FAQ: string = "70050A004";    // FAQ AI Help ID：

    static OPEN_DOMAIN: string =`https://${this.AI_HELPER_DOMAIN}`;
    static openUrl:URL;
    private static params: URLSearchParams;

    static isInit:boolean = false;

    static Init() {
        if (!this.params && !this.isInit){
            this.openUrl = new URL(this.OPEN_DOMAIN);
            this.params = this.openUrl.searchParams;
            this.isInit = true;
        }
    }

    static ShowFAQ() {
        if (Util.isLog) {
            console.log(this.Tag, `Show:FAQ`, `AIHelpSupport=${window.AIHelpSupport}`);
        }
        if (window.AIHelpSupport) {
            window.AIHelpSupport.show(this.AI_HELPER_NO_VIP);
        }
    }

    static ShowAIHelp(key: string) {
        // var languageCode = "en";
        // var userId = "0";
        // var userName = "";
        // var uuid = "";
        // var coreVersion = "0";
        // var coreSubVersion = "0";
        // var coreMinSubVersion = "0";

        const info = UserMgr.getTempUserInfo;
        const config = confJson;
        this.setParam('entranceId',key);//入口ID
        this.setParam('userName',`User_${info.userId}`)
        this.setParam('userTags',`VIP_${this.userVipLevel}_NEW`)
        this.setParam('applicationIdentifier',config.h5_package_name)
        this.setParam('applicationVersion',`${config.h5_version_code}`)
        this.setParam('applicationName',`${config.h5_app_name}`)
        this.setParam('totalMemory',UtilBrowser.deviceMemory)
        this.setParam('freeSpacePhone',UtilBrowser.getBrowserName)
        this.setParam('osVersion',UtilBrowser.getOsVersion)
        this.setParam('networkType',UtilBrowser.getNetworkType)
        this.setParam('countryCode',UtilBrowser.getSystemCountry)

        let baseUrl = `https://${this.AI_HELPER_DOMAIN}/webchatv5/#/${this.AI_HELPER_APP_ID}`;
        let params = this.params.toString();
        let url = `${baseUrl}?${params}`;
        window.open(url);
    }

    // 设置或更新参数
    static setParam(key:string, value:string) {
        if (this.params){
            this.params.set(key, value);
        }
    }

    static UpdateUserDate()
    {
        if (!this.isInit){
            return;
        }
    }

    //等待实现
    static get historyRecharge(){
        return 2;
    }

    //todo 等待实现
    static get userVipLevel(){
        return 3;
    }

    static ShowContactUs()
    {
        this.UpdateUserDate();

        // SdkTrack.Track512Commit("customer_click");
        //更换使用本地缓存的方式获取历史充值
        if (this.historyRecharge > 0)
        {
            if (this.userVipLevel >= 3)
            {
                if (Util.isLog) console.log(this.Tag, `Show:ContactUs -> ${this.AI_HELPER_BIG_VIP}`);
                this.ShowAIHelp(this.AI_HELPER_BIG_VIP);
            }
            else
            {
                if (Util.isLog) console.log(this.Tag, `Show:ContactUs -> ${this.AI_HELPER_VIP}`);
                this.ShowAIHelp(this.AI_HELPER_VIP);
            }
        }
        else
        {
            if (Util.isLog) console.log(this.Tag, `Show:ContactUs -> ${this.AI_HELPER_NO_VIP}`);
            this.ShowAIHelp(this.AI_HELPER_NO_VIP);
        }
    }


}


const AiHelpBox: React.FC = () => {
    const [apiKey, setApiKey] = useState(AiHelpManager.AI_HELPER_KEY);
    const [domain, setDomain] = useState(AiHelpManager.AI_HELPER_DOMAIN);
    const [appId, setAppId] = useState(AiHelpManager.AI_HELPER_APP_ID);

    const [isInit, setIsInit] = useState(false);
    useEffect(() => {
        AiHelpManager.Init();




        // 清理函数（可选）
        return () => {
            // 根据需要决定是否移除脚本或进行其他清理
            // document.head.removeChild(script);
        };
    }, [apiKey, domain, appId]);

    return (
        <AiHelpChat apiKey={apiKey} domain={domain} appId={appId}/>
    ); // 这个组件不需要渲染任何内容
};

export default AiHelpBox;
